<template>
  <div class="company_profile custom-font">
    <div class="bgImg">
      <img src="@assets/images/company_banner.png" alt="" />
    </div>
    <van-steps
      direction="vertical"
      active-color="#1989fa"
      inactive-color="#1989fa"
      active-icon="circle"
      inactive-icon="circle"
      v-for="item in info"
      :key="item.id"
    >
      <van-step>
        <h3>{{ item.name }}</h3>
        <p class="black">
          {{ item.introduction }}
        </p>
        <div class="img_produce">
          <img :src="item.images[0]" alt="" />
          <img :src="item.images[1]" alt="" />
          <img :src="item.images[2]" alt="" />
        </div>
      </van-step>
    </van-steps>
    <div class="footer">
      <p>
        <a href="http://www.beian.miit.gov.cn"
          >沪ICP备11047480号-3&nbsp;&nbsp;&nbsp;</a
        ><i class="c-icon-jgwablogo"></i>
      </p>
    </div>
  </div>
</template>
<script>
import { getCompanyData } from "@api/common";
import { baseInfo } from "@utils/config.js";

export default {
  data() {
    return {
      info: [],
      urlList: []
    };
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      getCompanyData().then(res => {
        console.log(res.data);
        this.info = res.data;
      });
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.bgImg {
  width: 100%;
  img {
    width: 100%;
  }
}
.black {
  padding: 0.1rem 0.2rem;
  margin-top: 10px;
}
p {
  font-family: "楷体", "楷体_GB2312";
  color: #505050;
}
h3 {
  width: 70px;
  height: 24px;
  line-height: 24px;
  background: #4c84ff;
  border-radius: 11.5px;
  font-family: SourceHanSansCN-Regular;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  margin-left: 0.2rem;
  margin-top: 0.2rem;
}
.img_produce {
  width: 100%;
  img {
    width: 32.2%;
    height: 100%;
    margin: 0.5%;
    margin-top: 17px;
  }
}
.footer {
  height: 40px;
  padding-top: 10px;
  p {
    text-align: center;
    color: #999;
    font-size: 13px;
  }
}
</style>
